import { FilterParams } from '@features/campaign-list/domain/filter';
import { Client } from '@features/clients';
import { Autocomplete, TextField } from '@mui/material';

type ClientSelectProps = {
  onChange: (client: FilterParams['selectedClient']) => void;
  clients: Client[];
  isLoading: boolean;
  value: Client | null;
};

export const ClientSelect = (props: ClientSelectProps) => {
  return (
    <Autocomplete
      id="client-select"
      size="small"
      sx={{ backgroundColor: 'white' }}
      loading={props.isLoading}
      options={props.clients}
      getOptionLabel={option => option.name}
      renderInput={params => <TextField {...params} label="Organization" />}
      onChange={(_, newValue) => props.onChange(newValue)}
      value={props.value}
    />
  );
};
